import Axios, { AxiosResponse } from 'axios';
import AxiosDefaultRequestConfig from './AxiosDefaultRequestConfig';
import AxiosPostProcessor from './AxiosPostProcessor';
import RecaptchaPublicConfig from './RecaptchaPublicConfig';

export class RecaptchaClientServiceStatic {
    getConfig(): Promise<AxiosResponse<RecaptchaPublicConfig>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/recaptcha/config`
        return AxiosPostProcessor.postProcess(Axios.get<RecaptchaPublicConfig>(url, AxiosDefaultRequestConfig.merge({ })));
    }
}

const RecaptchaClientService = new RecaptchaClientServiceStatic();
export default RecaptchaClientService;
